import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';

import {
  SET_REMOTE_VIDEO,
  ON_REMOTE_AUDIO_ENABLE,
  ON_REMOTE_AUDIO_DISABLE,
  ON_REMOTE_VIDEO_ENABLE,
  ON_REMOTE_VIDEO_DISABLE,
} from '../actions/remoteMedia';

import { STOP_CONSULTATION, STOP_CONSULTATION_LOCAL, HIDE_FINISHED_CONSULTATION } from '../actions/stopConsultation';
import { STOP_CALL_RECONNECTION_FAILED } from '../actions/videoConsultation';
import { CLEAR_CONVERSATION_PARAMS } from '../actions/_newConversationActions/checkActiveConversation';


const defaultState = {
  video: null,
  audioDisabled: false,
  videoDisabled: false,
};

export default createReducer(defaultState, {
  [SET_REMOTE_VIDEO]: (state, { meta: { remoteVideo: video } }) => ({
    ...state,
    video,
  }),

  [ON_REMOTE_AUDIO_ENABLE]: (state, { meta: { audioDisabled } }) => ({
    ...state,
    audioDisabled,
  }),
  [ON_REMOTE_AUDIO_DISABLE]: (state, { meta: { audioDisabled } }) => ({
    ...state,
    audioDisabled,
  }),

  [ON_REMOTE_VIDEO_ENABLE]: (state, { meta: { videoDisabled } }) => ({
    ...state,
    videoDisabled,
  }),
  [ON_REMOTE_VIDEO_DISABLE]: (state, { meta: { videoDisabled } }) => ({
    ...state,
    videoDisabled,
  }),

  [STOP_CALL_RECONNECTION_FAILED]: (state) => ({
    ...state,
    audioDisabled: false,
    videoDisabled: false,
  }),

  [CLEAR_CONVERSATION_PARAMS]: () => defaultState,
  [HIDE_FINISHED_CONSULTATION]: () => defaultState,
  [STOP_CONSULTATION.success]: () => defaultState,
  [STOP_CONSULTATION_LOCAL]: () => defaultState,

  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
